import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { store } from '@/store';
import SalesDocumentTable from '@/ui/views/salesdocumenttable/SalesDocumentTable.vue';
import { SalesDocumentTableConfig } from '@/ui/views/salesdocumenttable/salesdocument.types';
import Http from '../../../core/http/http.service';
import DashboardViewModel = Vertica.LouisPoulsen.Application.SalesDocuments.ViewModels.DashboardViewModel;
import { quoteService } from '@/ui/views/quotes/quote.service';
import { orderService } from '@/ui/views/orders/order.service';
import { invoiceService } from '@/ui/views/invoices/invoice.service';
import MostOrderedProducts from '@/ui/views/mostorderedproducts/MostOrderedProducts.vue';
import { QueryParams } from '@/core';
import queryParamsService from '@/core/query-params.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  props: {
    mostOrderedProductsOverview: null,
    orderOverview: null,
    invoiceOverview: null,
    quoteOverview: null,
    mostOrderedProductLines: null,
    allowPurchase: { type: Boolean },
    quickOrderFileUploadDescription: null,
    isUsMarket: { type: Boolean }
  },
  setup(__props: any) {



const model = ref<DashboardViewModel | null>(null);

const showMostOrderedProducts = ref<boolean>(false);
const listImageZoomModalToggled = ref<boolean>(false);
const listImageZoomImages = ref<CarouselImageViewObject[]>([]);

onMounted(() => Http.cancelableRequest('GET', 'dashboard/get', 'dashboardRequest')
    .then((response: DashboardViewModel) => {
        model.value = response;

        const params = queryParamsService.getParam(QueryParams.Expand);

        if (params && params === 'basket') {
            store.dispatch('navigation/toggleBasket');
        }
    }));

function onListImageZoom(images:CarouselImageViewObject[]) {
    listImageZoomModalToggled.value = true;
    listImageZoomImages.value = images;
}

const orderTableConfig = computed<SalesDocumentTableConfig>(() => orderService.tableConfig(false));
const invoiceTableConfig = computed<SalesDocumentTableConfig>(() => invoiceService.tableConfig(false));
const quotationTableConfig = computed<SalesDocumentTableConfig>(() => quoteService.tableConfig(false));
const fullScreenZoomImages = computed<any[]>(() => listImageZoomImages.value.map(img => ({ imageUrl: img.url })));

function mostOrderedProductsLoaded(hasResults) {
    showMostOrderedProducts.value = hasResults;
}

return { __sfc: true,model, showMostOrderedProducts, listImageZoomModalToggled, listImageZoomImages, onListImageZoom, orderTableConfig, invoiceTableConfig, quotationTableConfig, fullScreenZoomImages, mostOrderedProductsLoaded, SalesDocumentTable, MostOrderedProducts }
}

})